import apiFetch from '../apiFetch'

export default function (saleId, dossierDetails, token, lastAccessDate) {
  return apiFetch({ endPoint: `dossier/sale/${saleId}`, method: 'PUT', body: dossierDetails, token: token, lastAccessDate })
}
